<template>
  <div>
    <input v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="placeholder" :type="type" :autocomplete="autocomplete" />
    <label>{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: 'InputNumber',
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    validation: {
      type: String,
      default: '',
    },
    readonly: {
      default: null,
    },
    autocomplete: {
      type: String,
      autocomplete: null,
    },
  },
}
</script>
